import { useState } from "react";
import { Bell, BellRing } from "lucide-react";
import { toast } from "sonner";
import { pushAvailability, subscribePush } from "@/lib/push";
import { InstallSteps, pushErrorText, usePushStatus } from "@/components/site/AlertsSection";

// Ativa notificações desta entrega e, junto, os alertas gerais do site (novidades e baixas de preço).
export const TrackAlerts = ({ code }) => {
  const [status, setStatus] = usePushStatus();
  const [busy, setBusy] = useState(false);
  const avail = pushAvailability();
  const on = Array.isArray(status?.shipments) && status.shipments.includes(code);

  const enable = async () => {
    setBusy(true);
    try {
      setStatus(await subscribePush({ shipment: code, notify_all: true }));
      toast.success("Pronto! Você será avisado a cada etapa da entrega.");
    } catch (e) {
      toast.error(pushErrorText(e));
    } finally {
      setBusy(false);
    }
  };

  return (
    <div data-testid="track-alerts" className="rounded-[24px] border border-white/10 bg-[#111113] p-5 sm:p-6">
      <div className="flex items-start gap-3">
        {on ? <BellRing className="mt-0.5 h-5 w-5 shrink-0 text-emerald-300" /> : <Bell className="mt-0.5 h-5 w-5 shrink-0 text-white" />}
        <div>
          <p className="font-semibold text-white">{on ? "Notificações ativadas" : "Ative as notificações"}</p>
          <p className="mt-1 text-sm text-zinc-300">
            {on ? "Você vai receber um aviso no celular a cada etapa da entrega, além das novidades e baixas de preço da RC."
              : "Receba um aviso no celular a cada etapa da entrega. Você também fica sabendo das novidades e baixas de preço da RC."}
          </p>
        </div>
      </div>
      <div className="mt-4">
        {avail === "ios-install" && <InstallSteps />}
        {avail === "unsupported" && <p className="text-sm text-zinc-400">Este navegador não aceita notificações. Abra pelo Chrome (Android) ou adicione o site à Tela de Início no iPhone.</p>}
        {avail === "ok" && !on && (
          <button type="button" data-testid="track-alerts-enable" onClick={enable} disabled={busy}
            className="flex w-full items-center justify-center gap-2 rounded-full bg-white px-6 py-3.5 text-sm font-semibold text-black transition-transform hover:scale-[1.02] active:scale-95 disabled:opacity-60">
            <Bell className="h-4 w-4" /> {busy ? "Aguarde…" : "Ativar notificações"}
          </button>
        )}
      </div>
    </div>
  );
};
